export const isGood = (isAboveTarget: boolean, aboveTargetIsGood: boolean) => {
  if (isAboveTarget) {
    if (aboveTargetIsGood) {
      return true;
    } else {
      return false;
    }
  } else {
    if (aboveTargetIsGood) {
      return false;
    } else {
      return true;
    }
  }
};

const getColor = (isAboveTarget: boolean, aboveTargetIsGood: boolean) => {
  if (isGood(isAboveTarget, aboveTargetIsGood)) {
    return 'var(--color-status-success)';
  } else {
    return 'var(--color-status-danger)';
  }
};

export default getColor;
